<template>
  <div>
    <vx-card title="Новое блюдо" class="p-6">
      <vs-input
        class="w-full mb-4"
        v-validate="'required'"
        label="Название"
        name="Название"
        v-model="dish.name"
      />
      <span class="text-danger text-sm">{{ errors.first("Название") }}</span>

      <vs-input
        class="w-full mb-4"
        v-validate="'required'"
        label="Описание"
        name="Описание"
        v-model="dish.description"
      />
      <span class="text-danger text-sm">{{ errors.first("Описание") }}</span>

      <vs-input
        class="w-full mb-4"
        v-validate="'required'"
        label="Цена, руб."
        name="Цена"
        type="number"
        v-model.number="dish.price"
      />
      <span class="text-danger text-sm">{{ errors.first("Цена") }}</span>

      <vs-input
        class="w-full mb-4"
        v-validate="'required'"
        label="Вес, кг."
        name="Вес"
        type="number"
        v-model.number="dish.weight"
      />
      <span class="text-danger text-sm">{{ errors.first("Вес") }}</span>

      <picture-input
        ref="pictureInput"
        class="mt-10 z-10"
        width="200"
        height="200"
        margin="1"
        accept="image/jpeg,image/png"
        size="15"
        buttonClass="vs-component vs-button vs-con-loading__container vs-button-primary vs-button-relief"
        :customStrings="{
          upload: '<h1>Загрузить изображение</h1>',
          drag: 'Загрузите изображение',
          change: 'Изменить изображение',
          remove: 'Удалить изображение',
          select: 'Выбрать изображение',
        }"
      >
      </picture-input>

      <vs-button
        @click="createDish"
        :disabled="!validateForm"
        color="success"
        class="mr-5 vs-con-loading__container"
        ref="loadableButton"
        type="relief"
      >
        Создать
      </vs-button>
    </vx-card>
  </div>
</template>
<script>
import { API_URL } from "@/.env";
import PictureInput from "vue-picture-input";

export default {
  data: () => ({
    BASE_URL: API_URL,
    dish: {
      name: "",
      description: "",
      price: 0,
      weight: 0,
    },
  }),
  components: {
    PictureInput,
  },
  watch: {},
  computed: {
    validateForm() {
      return (
        !this.errors.any() &&
        this.dish.name !== "" &&
        this.dish.description !== "" &&
        this.dish.price !== "" &&
        this.dish.weight !== ""
      );
    },
  },
  methods: {
    notification(title, message, color) {
      this.$vs.notify({
        title: title,
        text: message,
        color: color,
        position: "top-center",
        time: "4000",
        icon: "delete",
      });
    },
    uploadImage(idDish) {
      return this.$load(async () => {
        if (this.$refs.pictureInput.file) {
          await this.$api.cafe.updateImageProduct(idDish, {
            imageFile: this.$refs.pictureInput.file,
          });
        }
      });
    },
    createDish() {
      let payload = {
        name: this.dish.name,
        description: this.dish.description,
        price: this.dish.price,
        weight: this.dish.weight,
      };

      this.$load(async () => {
        try {
          let res = await this.$api.cafe.createDish(payload);

          this.uploadImage(res.data.id).then((response) => {
            if (response) {
              this.notification("Успешно", "Блюдо создано", "success");
            } else {
              this.notification(
                "Успешно",
                "Блюдо создано, изображение не добавлено",
                "success"
              );
            }
            this.$router.push({ name: "cafe-dishes" });
          });
        } catch (error) {
          this.notification("Ошибка", "Не удалось создать блюдо", "danger");
        }
      });
    },
  },
  created() {},
  mounted() {},
};
</script>